module.exports = __webpack_public_path__ + "static/media/contact.6ffd1038.jpg";